<template lang="pug">
.container-fluid(v-if="evento")
	div.mb-2(v-if="evento.ImagenCabecera")
		img(:src="'/src/modulos/eventos/php/api/getImagen.php?imagen=' + evento.ImagenCabecera", style="width: 100%;")
	.row
		.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-3
			.card
				.card-body.bg-warning.text-center
					h3 {{evento.Titulo}}
				table.table.table-striped.m-0
					tbody
						tr
							td.bg-dark.text-white(colspan="2")
								h5
									span.fa.fa-info-circle.mr-2
									| Detalles
						tr
							td
								b Inicio:
							td
								span.fa.fa-calendar.mr-2
								| {{evento.FechaInicioEvento | moment('DD-MM-YYYY')}}
								span.fa.fa-clock-o.ml-4.mr-2
								| {{evento.FechaInicioEvento | moment('HH:mm')}}
						tr
							td
								b Fin:
							td
								span.fa.fa-calendar.mr-2
								| {{evento.FechaFinEvento | moment('DD-MM-YYYY')}}
								span.fa.fa-clock-o.ml-4.mr-2
								| {{evento.FechaFinEvento | moment('HH:mm')}}
						tr
							td.bg-dark.text-white(colspan="2")
								h5
									span.fa.fa-list.mr-2
									| Inscripciones
						tr
							td
								b Inicio:
							td
								span.fa.fa-calendar.mr-2
								| {{evento.FechaInicioInscripciones | moment('DD-MM-YYYY')}}
								span.fa.fa-clock-o.ml-4.mr-2
								| {{evento.FechaInicioInscripciones | moment('HH:mm')}}
						tr
							td
								b Fin:
							td
								span.fa.fa-calendar.mr-2
								| {{evento.FechaFinInscripciones | moment('DD-MM-YYYY')}}
								span.fa.fa-clock-o.ml-4.mr-2
								| {{evento.FechaFinInscripciones | moment('HH:mm')}}

						tr
							td
								b Inscritos
							td {{inscritos.reduce((acum, ins) => {return acum + ins.numeroAsistentes}, 0)}} inscritos
						//- tr
						//- 	td
						//- 		b Asistentes previstos
						//- 	td {{asistentes.length}} asistentes
						tr
							td
								b Asistentes confirmados
							td {{asistentesConfirmados}} asistentes
						
						tr
							td.bg-dark.text-white(colspan="2")
								h5
									span.fa.fa-euro.mr-2
									| Pagos
						tr
							td
								b Importe pagado
							td {{importes.ImportePagado | currency('')}} €
						tr
							td
								b Importe comisión
							td {{importes.ImporteComision | currency('')}} €
						tr
							td
								b Importe percibido
							td {{importes.ImportePercibido | currency('')}} €
				.card-footer
					button.mr-2.btn.btn-primary(@click="insertando = evento.EventoID")
						span.fa.fa-building.mr-2
						| Registrar empresa


		.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-9
			.card
				.card-header.bg-dark.text-white
					.row
						.col.text-left
							span.fa.fa-list.mr-2
							| Asistentes
							download-excel.ml-3(
								v-if="listadoAsistentes.length > 0"
								class   = "btn btn-warning ml-2"
								:data   = "json_data"
								:fields = "json_fields"
								:meta   = "json_meta"
								name	= "asistentes.xls")

								span.fa.fa-download.mr-2
								| XLS
						.col.text-right
							.input-group.input-group-sm
								.input-group-prepend
									.input-group-text
										span.fa.fa-search
								input.form-control(v-model="filtro.cadena", placeholder="Buscar por nombre o empresa")
								.input-group-append
									button.btn(:class="(filtro.soloConfirmados) ? 'btn-primary' : ''", @click="filtro.soloConfirmados = !filtro.soloConfirmados")
										span.fa.fa-check
								.input-group-append
									button.btn(:class="(filtro.soloPagados) ? 'btn-primary' : ''", @click="filtro.soloPagados = !filtro.soloPagados")
										span.fa.fa-euro
			table.m-0.table.table-striped(style="background-color: white;")
				thead
					tr
						th(@click="ordenar('ID')", style="cursor: pointer;")
							span ID
							span.ml-2(v-if="sort.campo === 'ID'")
								span.fa(:class="(sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'")
						th(@click="ordenar('Nombre')", style="cursor: pointer;")
							span Nombre
							span.ml-2(v-if="sort.campo === 'Nombre'")
								span.fa(:class="(sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'")
						th(@click="ordenar('Empresa')", style="cursor: pointer;")
							span Empresa
							span.ml-2(v-if="sort.campo === 'Empresa'")
								span.fa(:class="(sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'")
						th(@click="ordenar('Email')", style="cursor: pointer;")
							span E-mail
							span.ml-2(v-if="sort.campo === 'Email'")
								span.fa(:class="(sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'")
						th(@click="ordenar('Telefono')", style="cursor: pointer;")
							span Teléfono
							span.ml-2(v-if="sort.campo === 'Telefono'")
								span.fa(:class="(sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'")
						th(@click="ordenar('FechaInscrito')", style="cursor: pointer;")
							span Fecha ins.
							span.ml-2(v-if="sort.campo === 'FechaInscrito'")
								span.fa(:class="(sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'")
						th
						th
				tbody
					tr.empresa(
						v-for="asis in listadoAsistentes"
						:key="asis.AsistenteID",
						style="cursor: pointer;",
						@click="editarRegistro(asis.InscritoID)"
					)
						td {{asis.InscritoID}}.{{asis.AsistenteID}}
						td {{asis.Nombre}}
						td 
							| {{asis.Empresa}}
							div(v-if="asis.NumeroAsistentes", style="opacity:0.6;") {{asis.NumeroAsistentes}} asistentes
						td {{asis.Email}}
						td {{asis.Telefono}}
						td {{asis.FechaInscrito | moment('DD-MM-YYYY hh:mm')}}
						td.text-right
							button.btn.btn-sm.btn-primary(v-if="!asis.Asiste && asis.AsistenteID", title="Asiste", @click="asiste(asis.AsistenteID, $event)")
								span.fa.fa-check
							button.btn.btn-sm.btn-danger(v-if="asis.Asiste && asis.AsistenteID", title="No ha asistido", @click="noAsiste(asis.AsistenteID, $event)")
								span.fa.fa-trash
						td.text-right(@click="verDetallesPago($event, asis)")
							button.btn.btn-sm.btn-block.btn-warning.ml-2(v-if="asis.AnulacionID")
								span.fa.fa-euro.mr-2
								| Anulado {{asis.ImportePagado | currency('')}} €
							button.btn.btn-sm.btn-block.btn-success.ml-2(v-else-if="asis.CaptureID")
								span.fa.fa-euro.mr-2
								| Pagado {{asis.ImportePagado | currency('')}} €
							button.btn.btn-sm.btn-block.btn-danger(v-else)
								| Pago pendiente
	Insertar(v-if="insertando", @cerrar="cierraEditor", :EventoID="insertando", @actualizar="getEvento($route.params.id)", :InscritoID="InscritoID")
	modal(v-if="detallesPago", :max-width="400")
		.card.text-left
			.card-header.bg-dark.text-white
				span.fa.fa-euro.mr-2
				| Detalles del pago
				button.close(@click="detallesPago = null") &times;
			table.table.table-striped
				tbody
					tr.bg-warning(v-if="detallesPago.AnulacionID")
						td.text-center(colspan="2", style="font-size:1.5em;font-weight:bold")
							span.fa.fa-ban
							br
							| Incripción anulada e importe devuelto
					tr.bg-warning(v-else-if="!detallesPago.CaptureID")
						td.text-center(colspan="2", style="font-size:1.5em;font-weight:bold")
							span.fa.fa-exclamation-triangle
							br
							| Pago no completado
					tr
						td(style="font-weight:bold;") Fecha pagado
						td {{detallesPago.FechaPagado}}
					tr
						td(style="font-weight:bold;") Importe
						td {{detallesPago.ImportePagado | currency('')}} €
					tr
						td(style="font-weight:bold;") Importe comisión
						td {{detallesPago.ImporteComision | currency('')}} €
					tr
						td(style="font-weight:bold;") Importe percibido
						td {{detallesPago.ImportePercibido | currency('')}} €
					tr
						td(style="font-weight:bold;") OrderID
						td {{detallesPago.OrderID}}
					tr
						td(style="font-weight:bold;") CaptureID
						td {{detallesPago.CaptureID}}
					tr.bg-danger.text-white(v-if="detallesPago.AnulacionID")
						td(style="font-weight:bold;") ID anulación
						td {{detallesPago.AnulacionID}}	
</template>


<script>
import Insertar from './insertar'
export default {
	components: {
		Insertar
	},
	data () {
		return {
			evento: null,
			asistentes: [],
			filtro: {
				cadena: '',
				soloConfirmados: false,
				soloPagados: false
			},
			insertando: null,
			InscritoID: null,
			intervalo: null,
			sort: {
				campo: 'Nombre',
				orden: 1
			},
			detallesPago: null
		}
	},
	created () {
		if (!this.$route.params.id) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: 'No has seleccionado un evento válido'
			})
		} else {
			this.getEvento(this.$route.params.id)

			this.intervalo = window.setInterval(() => {
				this.getEvento(this.$route.params.id)
			}, 5000)
		}
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
	},
	computed: {
		json_data () {
			return this.listadoAsistentes.map(a => {
				a.ID = a.InscritoID + '-' + a.AsistenteID
				a.Fecha = this.$moment(a.FechaInscrito * 1000).format('DD-MM-YYYY HH:mm')
				return a
			})
		},
		json_fields () {
			const arr = {
				ID: 'ID',
				Nombre: 'Nombre',
				Empresa: 'Empresa',
				Email: 'Email',
				Telefono: 'Telefono',
				Fecha: 'Fecha'
			}
			return arr
		},
		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		},
		inscritos () {
			return Array.from(this.asistentes.reduce((ant, actual) => {
				if (ant.has(actual.InscritoID)) {
					const ins = ant.get(actual.InscritoID)
					ins.asistentes.push(actual)
					if (actual.NumeroAsistentes) {
						ins.numeroAsistentes += actual.NumeroAsistentes
					}
				} else {
					ant.set(actual.InscritoID, {
						Empresa: actual.Empresa,
						Telefono: actual.Telefono,
						Email: actual.Email,
						numeroAsistentes: actual.NumeroAsistentes || 0,
						asistentes: [actual]
					})
				}
				return ant
			}, new Map())).map(a => a[1])
		},
		listadoAsistentes () {
			let reg = /.*/ig
			if (this.filtro.cadena) {
				reg = new RegExp(this.filtro.cadena, 'ig')
			}
			let asis = this.asistentes.map(a => {
				a.Nombre = a.Nombre + ' ' + a.Apellidos
				return a
			}).filter(a => {
				const nombre = a.Nombre
				if (this.filtro.cadena && (!reg.test(nombre) && !reg.test(a.Empresa))) {
					return false
				}
				if (this.filtro.soloConfirmados && !a.Asiste) {
					return false
				}
				if (this.filtro.soloPagados && a.OrderID && (!a.CaptureID || a.AnulacionID)) {
					return false
				}

				return true
			})

			if (!this.sort.campo) {
				return asis
			}

			this.sort.orden = (!this.sort.orden) ? 'asc' : this.sort.orden

			return asis.sort((anterior, siguiente) => {
				let valAnterior
				let valSiguiente

				if (this.sort.campo === 'Nombre') {
					valAnterior = anterior.Nombre + ' ' + anterior.Apellidos
					valSiguiente = siguiente.Nombre + ' ' + siguiente.Apellidos
				} else if (this.sort.campo === 'ID') {
					valAnterior = anterior.InscritoID + '.' + anterior.AsistenteID
					valSiguiente = siguiente.InscritoID + '.' + siguiente.AsistenteID
				} else {
					valAnterior = anterior[this.sort.campo]
					valSiguiente = siguiente[this.sort.campo]
				}

				if (valAnterior > valSiguiente) {
					return this.sort.orden
				} else if (valAnterior < valSiguiente) {
					return this.sort.orden * -1
				} else {
					return 0
				}
			})
		},
		asistentesConfirmados () {
			return this.asistentes.filter(a => {
				if (!a.OrderIDID && a.Asiste) {
					return a
				} else if (a.OrderID && a.CaptureID && !a.AnulacionID) {
					return a
				}
			}).reduce((acum, ins) => {
				if (ins.NumeroAsistentes) {
					return acum + ins.NumeroAsistentes
				} else {
					return acum + 1
				}
			}, 0)
		},
		importes () {
			return this.asistentes.reduce((acum, asis) => {
				if (asis.CaptureID && !asis.AnulacionID) {
					acum.ImportePagado = (typeof acum.ImportePagado !== 'undefined') ? acum.ImportePagado : 0
					acum.ImporteComision = (typeof acum.ImporteComision !== 'undefined') ? acum.ImporteComision : 0
					acum.ImportePercibido = (typeof acum.ImportePercibido !== 'undefined') ? acum.ImportePercibido : 0

					if (asis.ImportePagado) {
						acum.ImportePagado = acum.ImportePagado + asis.ImportePagado
						acum.ImporteComision = acum.ImporteComision + asis.ImporteComision
						acum.ImportePercibido = acum.ImportePercibido + asis.ImportePercibido
					}
				}
				return acum
			}, {})
		}
	},
	methods: {
		getEvento (id) {
			this.$http.post('eventos/php/api/getEvento.php', {EventoID: id})
				.then(res => {
					this.evento = res.data

					// Obtenemos los asistentes
					this.$http.post('eventos/php/api/getAsistentes.php', {EventoID: id})
						.then(resA => {
							this.asistentes = resA.data
						})
						.catch(eA => {
							this.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: eA.response.data.error
							})
						})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		ordenar (campo) {
			if (this.sort.campo === campo) {
				this.sort.orden = this.sort.orden * -1
			} else {
				this.sort.campo = campo
				this.sort.orden = 1
			}
		},
		editarRegistro (InscritoID) {
			this.insertando = this.evento.EventoID
			this.InscritoID = InscritoID
		},
		cierraEditor () {
			this.insertando = null
			this.InscritoID = null
		},
		verDetallesPago (ev, asis) {
			ev.preventDefault()
			ev.stopPropagation()
			this.detallesPago = asis
		},
		asiste (AsistenteID, ev) {
			ev.preventDefault()
			ev.stopPropagation()
			this.$http.post('eventos/php/api/setAsistencia.php', {AsistenteID: AsistenteID})
				.then(() => {
					for (let i in this.asistentes) {
						if (this.asistentes[i].AsistenteID === AsistenteID) {
							this.asistentes[i].Asiste = true
						}
					}

					this.$forceUpdate()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		noAsiste (AsistenteID, ev) {
			ev.preventDefault()
			ev.stopPropagation()
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar asistencia',
				mensaje: '¿Quieres marcar que esta persona no ha asistido al evento?',
				callback: acepta => {
					if (acepta) {
						this.$http.post('eventos/php/api/delAsistencia.php', {AsistenteID: AsistenteID})
							.then(() => {
								for (let i in this.asistentes) {
									if (this.asistentes[i].AsistenteID === AsistenteID) {
										this.asistentes[i].Asiste = false
									}
								}

								this.$forceUpdate()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>


<style scoped>
.empresa {
	cursor: pointer;
}
.empresa:hover {
	background-color: #e0e0e0;
	color: darkslategray;
}
</style>



// WEBPACK FOOTER //
// src/modulos/eventos/vue/components/visualizar/visualizar.vue